
import type { PuzzleData } from '@/lib/types/puzzle-types';
import { allLogicRules } from '../logic-rules';
import type { LogicRule } from '../logic-rules';
import { verifyOrderMatchesReasoning } from '../puzzle/puzzle-utils';

export function validatePuzzle(puzzleData: unknown): PuzzleData {
  console.log('Validating puzzle data:', puzzleData);
  
  if (!puzzleData || typeof puzzleData !== 'object') {
    console.error('Invalid puzzle data format');
    throw new Error('Invalid puzzle data format');
  }

  const data = puzzleData as any;

  // Validate required fields
  if (!Array.isArray(data.words)) {
    throw new Error('Invalid puzzle data: missing or invalid words array');
  }

  if (!data.correctRule || typeof data.correctRule !== 'object') {
    throw new Error('Invalid puzzle data: missing or invalid correctRule');
  }

  if (!Array.isArray(data.correctOrder)) {
    throw new Error('Invalid puzzle data: missing or invalid correctOrder array');
  }

  if (!Array.isArray(data.logicRules)) {
    throw new Error('Invalid puzzle data: missing or invalid logicRules array');
  }

  // Find and validate the correct rule
  const correctRule = allLogicRules.find(rule => rule.id === data.correctRule.id);
  if (!correctRule) {
    throw new Error(`Invalid correctRule: no matching rule found for id ${data.correctRule.id}`);
  }

  // If reasoning is provided, verify it matches the order and correct if needed
  let correctOrder = [...data.correctOrder];
  if (data.correctRule.reasoning) {
    console.log('Verifying reasoning matches order...');
    const { consistent, correctedOrder } = verifyOrderMatchesReasoning(
      data.words, 
      data.correctOrder, 
      data.correctRule.reasoning
    );
    
    if (!consistent && correctedOrder) {
      console.warn('Inconsistency detected in puzzle data! Correcting order based on reasoning...');
      correctOrder = correctedOrder;
    }
  }

  // Validate logic rules
  const logicRules = data.logicRules.map(ruleData => {
    const rule = allLogicRules.find(r => r.id === ruleData.id);
    if (!rule) {
      throw new Error(`Invalid logicRule: no matching rule found for id ${ruleData.id}`);
    }
    return rule;
  });

  const validatedPuzzle: PuzzleData = {
    words: data.words,
    correctRule,
    correctOrder: correctOrder,
    logicRules,
    date: data.date
  };

  console.log('Puzzle validation successful');
  return validatedPuzzle;
}
